module.exports = __webpack_public_path__ + "img/transport_smvf.28435582.jpg";